import { currencyMaskBRL, phoneApplyMask } from "helpers/utils";
import { format } from "date-fns";

import { IAdiantamentoEvento } from "interfaces/adiantamento";

export type FormAdiantamentoValues = {
  id?: number;
  urlComprovante?: string;
  identificacaoTransacao: string;
  solicitante: string;
  dataSolicitacao: string;
  valorTransacao: string | number;
  dataPagamento: string;
  nomeResponsavel: string;
  celPhone: string;
  status: IAdiantamentoEvento["status"];
  obs: string;
  contaFinanceiraId: string;
};

const initialValuesFormAdiantamento: FormAdiantamentoValues = {
  urlComprovante: "",
  nomeResponsavel: "",
  solicitante: "",
  dataSolicitacao: format(new Date(), "yyyy-MM-dd"),
  identificacaoTransacao: "",
  valorTransacao: "",
  dataPagamento: format(new Date(), "yyyy-MM-dd"),
  status: "Pago",
  celPhone: "",
  obs: "",
  contaFinanceiraId: "",
};

const initialValuesFormAdiantamentoEdit = (
  adiantamento: IAdiantamentoEvento
): FormAdiantamentoValues => {
  return {
    id: adiantamento.id,
    urlComprovante: adiantamento.urlComprovante,
    nomeResponsavel: adiantamento.nomeResponsavel,
    solicitante: adiantamento.solicitante,
    dataSolicitacao: format(new Date(), "yyyy-MM-dd"),
    identificacaoTransacao: adiantamento.identificacaoTransacao,
    valorTransacao: adiantamento.valorTransacao
      ? currencyMaskBRL(String(Math.round(adiantamento.valorTransacao * 100)))
      : "",
    dataPagamento: adiantamento.dataPagamento
      ? format(new Date(adiantamento.dataPagamento), "yyyy-MM-dd")
      : format(new Date(), "yyyy-MM-dd"),
    status: adiantamento.status,
    celPhone: phoneApplyMask(adiantamento.celPhone),
    obs: adiantamento.obs,
    contaFinanceiraId: adiantamento.contaFinanceiraId ?? "",
  };
};

export { initialValuesFormAdiantamento, initialValuesFormAdiantamentoEdit };
